import { BookletList } from "@/@types/Booklet";
import Link from "next/link";
import { FallbackImage } from "../common";
import NoContent from "../common/NoContent";
import IconSprite from "../common/IconSprite";

type Props = {
  bookletsList?: BookletList | undefined;
};

export default function BookletsListCard({ bookletsList }: Props) {
  if (
    !bookletsList ||
    !bookletsList.data ||
    !bookletsList.data.booklets ||
    bookletsList.data.booklets.length === 0
  ) {
    return <NoContent />;
  }

  return (
    <div className="grid grid-cols-2 gap-6 sm:grid-cols-2 lg:grid-cols-2 w-full ">
      {bookletsList.data.booklets.map((booklet) => {
        const formatDate = new Date(booklet.date)
          .toLocaleDateString("es-ES", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })
          .toUpperCase();

        const bookletLink = `/literatura/${booklet.category_slug}/${booklet.slug}`;

        return (
          <Link
            key={booklet.slug}
            href={bookletLink}
            className="border bg-white shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 flex flex-col md:flex-row"
          >
            <div className="aspect-square md:w-1/3 md:aspect-auto">
              <FallbackImage
                width={550}
                height={550}
                src={booklet.image || "/images/img_no_found.jpg"}
                alt={booklet.title || "Título no disponible"}
                className="w-full h-full object-cover"
              />
            </div>

            <div className="w-full md:w-2/3 p-4 flex flex-col justify-between">
              <div>
                <p className="text-xs md:text-sm font-bold bg-dark02 md:bg-black text-white inline-block px-2 md:px-3 py-1 rounded-md uppercase mb-4 w-fit">
                  {booklet.category}
                </p>

                <h3
                  className="text-base md:text-lg font-bold text-dark01 line-clamp-2 uppercase overflow-hidden text-ellipsis
  "
                >
                  {booklet.title}
                </h3>
              </div>

              <div className="flex justify-between items-end mt-4 text-dark01">
                <span className="text-sm">{formatDate}</span>
                <span className="text-sm font-bold hover:underline flex items-center gap-1">
                  SEGUIR LEYENDO
                  <IconSprite id="ic_arrow_right" className="w-3 h-3" />
                </span>
              </div>
            </div>
          </Link>
        );
      })}
    </div>
  );
}
